import './styles/global.css';
import { GAME_CONFIG } from './app/GameConfig';
import { GameApp } from './app/GameApp';

const app = document.querySelector<HTMLDivElement>('#app');

if (!app) {
  throw new Error('Application root #app was not found.');
}

document.title = GAME_CONFIG.projectFullTitle;
app.classList.add('game-root');

const game = new GameApp(app);

void game
  .init()
  .then(() => {
    if (import.meta.env.DEV && import.meta.env.MODE === 'test') {
      window.__KONAI_E2E__ = game.createE2EApi();
    }
  })
  .catch((error: unknown) => {
    console.error(error);
    app.innerHTML = `
    <main class="bootstrap-screen" aria-label="${GAME_CONFIG.projectFullTitle} 起動エラー">
      <section class="bootstrap-panel">
        <p class="bootstrap-kicker">Startup Error</p>
        <h1>${GAME_CONFIG.projectTitle}</h1>
        <p>PixiJS application failed to initialize.</p>
      </section>
    </main>
  `;
  });
